export default __webpack_public_path__ + "static/media/pic2.031e0f02.jpg";